import type { SelectOption } from '~/components/molecule/MultiSelectInput';

export const APP_TYPES: Array<SelectOption> = [
  {
    key: 'BIEDWIJZER',
    label: 'BIEDWIJZER',
    payload: {
      value: 'BIEDWIJZER',
      filterLabel: 'Biedwijzer',
      tagLabel: 'Biedwijzer',
    },
  },
  {
    key: 'VALUATION_REPORT',
    label: 'VALUATION_REPORT',
    payload: {
      value: 'VALUATION_REPORT',
      filterLabel: 'Valuation report',
      tagLabel: 'Valuation report',
    },
  },
  {
    key: 'FUNDA',
    label: 'FUNDA',
    payload: { value: 'FUNDA', filterLabel: 'Funda', tagLabel: 'Funda' },
  },
  {
    key: 'TRUSTOO',
    label: 'TRUSTOO',
    payload: { value: 'TRUSTOO', filterLabel: 'Trustoo', tagLabel: 'Trustoo' },
  },
  {
    key: 'BB_WAARDECHECK',
    label: 'BB_WAARDECHECK',
    payload: {
      value: 'BB_WAARDECHECK',
      filterLabel: 'BB Waardecheck',
      tagLabel: 'BB Waardecheck',
    },
  },
  {
    key: 'ZAPIER',
    label: 'ZAPIER',
    payload: { value: 'ZAPIER', filterLabel: 'Zapier', tagLabel: 'Zapier' },
  },
  {
    key: 'REALWORKS',
    label: 'REALWORKS',
    payload: {
      value: 'REALWORKS',
      filterLabel: 'Realworks',
      tagLabel: 'Realworks',
    },
  },
  {
    key: 'VBO_WAARDECHECK',
    label: 'VBO_WAARDECHECK',
    payload: {
      value: 'VBO_WAARDECHECK',
      filterLabel: 'Matrixian Waardecheck',
      tagLabel: 'Matrixian Waardecheck',
    },
  },
  {
    key: 'HYPOTHEEKBOND',
    label: 'HYPOTHEEKBOND',
    payload: {
      value: 'HYPOTHEEKBOND',
      filterLabel: 'Hypotheekbond',
      tagLabel: 'Hypotheekbond',
    },
  },
  {
    key: 'ARXGROEP',
    label: 'ARXGROEP',
    payload: {
      value: 'ARXGROEP',
      filterLabel: 'Arxgroep',
      tagLabel: 'Arxgroep',
    },
  },
  {
    key: 'ENVEN',
    label: 'ENVEN',
    payload: { value: 'ENVEN', filterLabel: 'Enven', tagLabel: 'Enven' },
  },
  {
    key: 'HOMEKEUR',
    label: 'HOMEKEUR',
    payload: {
      value: 'HOMEKEUR',
      filterLabel: 'Homekeur',
      tagLabel: 'Homekeur',
    },
  },
  {
    key: 'WOZ_COMPLAINT',
    label: 'WOZ_COMPLAINT',
    payload: {
      value: 'WOZ_COMPLAINT',
      filterLabel: 'WoZ Complaint',
      tagLabel: 'WoZ Complaint',
    },
  },
  {
    key: 'SUSTAINABILITY_REPORT',
    label: 'SUSTAINABILITY_REPORT',
    payload: {
      value: 'SUSTAINABILITY_REPORT',
      filterLabel: 'Sustainability report',
      tagLabel: 'Sustainability report',
    },
  },
  {
    key: 'CONTAQT',
    label: 'CONTAQT',
    payload: { value: 'CONTAQT', filterLabel: 'Contakt', tagLabel: 'Contakt' },
  },
  {
    key: 'STELLAX_AI',
    label: 'STELLAX_AI',
    payload: {
      value: 'STELLAX_AI',
      filterLabel: 'Stellax AI',
      tagLabel: 'Stellax AI',
    },
  },
];
